import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    width: 100%;
    position: relative;

    input {
        width: 100%;
        height: 3.5em;
        padding: 0 1em;
        color: ${vars.colorText};
        border-radius: .5em;
        font-size: 0.9em;
        border: .1em solid #F1F1F1;

        &::placeholder {
            color: ${vars.colorTextLight};
        }

        &:disabled {
            opacity: 0.5;
            background-color: transparent;
        }
    }

    .layout-forms-input-wrapper {
        .internal-wrapper {
            border: none;
        }

        > * {
            width: 100%;

            .react-datepicker {
                width: 100%;
                display: flex;

                .react-datepicker__month-container {
                    width: 100%;

                    .react-datepicker__month {
                            .react-datepicker__week {
                                .react-datepicker__day {
                                    line-height: 1.2rem;
                                    margin: 2px 4px;
                                }
                            }
                        }
                }

                .react-datepicker__time-container  {
                    .react-datepicker__time {
                        .react-datepicker__time-box {
                            .react-datepicker__time-list {
                                height: 162px !important;
                            }
                        }
                    }
                }
            }

            .react-datepicker-wrapper {
                width: 100%;
            }

            .react-datepicker-popper {
                z-index: 9;

                .react-datepicker {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    width: 100%;

                    .react-datepicker__month-container {
                        width: 100%;
                    }
                }
            }
        }
    }

    &.no-value {
        .layout-forms-input-wrapper {
            > * {
                .react-datepicker {
                    .react-datepicker__month-container {
                        .react-datepicker__month {
                            .react-datepicker__week {
                                .react-datepicker__day {
                                    color: #000;
                                    background-color: transparent;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    &.decorator-left {
        input {
            padding-left: 2.5em;
        }
    }
    &.decorator-right {
        input {
            padding-right: 2.5em;
        }
    }

    .error-message {
        display: inline-block;
        position: relative;
        left: 0;
        color: tomato;
    }

	@media all and (max-width: ${vars.mobileL}) {

		input {
			font-size: 1.3em;
		}
    }
`;
